
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baike",
      function () {
        return require("private-next-pages/baike/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baike"])
      });
    }
  